// Server-side export helper. Hits a Laravel endpoint that returns a CSV stream
// (with Content-Disposition: attachment) and triggers a browser download with auth.
//
// Use:
//   await fetchAndDownload("/employee-tasks/export", { status: "completed", ... }, "tasks");
import { API_BASE_URL as BASE } from "../api/baseUrl";

export async function fetchAndDownload(path, params = {}, fallbackBaseName = "export") {
  const url = new URL(BASE + path, window.location.origin);
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v === "" || v == null) return;
    // Arrays go as key[]=a&key[]=b so Laravel parses them back into an array.
    if (Array.isArray(v)) {
      v.forEach((item) => {
        if (item !== "" && item != null) url.searchParams.append(`${k}[]`, item);
      });
      return;
    }
    url.searchParams.set(k, v);
  });

  const token = localStorage.getItem("access_token");
  const headers = { Accept: "text/csv,application/vnd.ms-excel,*/*" };
  if (token) headers.Authorization = `Bearer ${token}`;

  let res;
  try {
    res = await fetch(url.toString(), { headers, credentials: "omit" });
  } catch (netErr) {
    // Network-level failure (server down, DNS, refused). Surface a friendlier message.
    const err = new Error(
      `Could not reach ${BASE} — make sure the Laravel server is running and that REACT_APP_API_BASE_URL points to it.`,
    );
    err.cause = netErr;
    throw err;
  }

  if (!res.ok) {
    let message = `Export failed (${res.status})`;
    try {
      const body = await res.json();
      if (body?.message) message = body.message;
    } catch { /* not JSON */ }
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }

  const blob = await res.blob();
  const cd = res.headers.get("Content-Disposition") || "";
  const match = cd.match(/filename\*?=(?:UTF-8'')?"?([^";]+)/i);
  const stamp = new Date().toISOString().slice(0, 10);
  const filename = match ? decodeURIComponent(match[1]) : `${fallbackBaseName}_${stamp}.csv`;

  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 0);
}
